/**
 * @generated SignedSource<<2902191353f153ed33efdf8da87f421c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MeetingRecordingVisibility = "PRIVATE" | "PUBLIC" | "WORKSPACE";
export type SendNotesRecordingModal_updateRecordingVisibilityMutation$variables = {
  noteId: string;
  visibility: MeetingRecordingVisibility;
};
export type SendNotesRecordingModal_updateRecordingVisibilityMutation$data = {
  readonly updateMeetingRecordingVisibility: {
    readonly note: {
      readonly id: string;
      readonly meetingRecordingLink: {
        readonly id: string;
        readonly visibility: MeetingRecordingVisibility;
      };
    };
  } | null;
};
export type SendNotesRecordingModal_updateRecordingVisibilityMutation$rawResponse = {
  readonly updateMeetingRecordingVisibility: {
    readonly note: {
      readonly id: string;
      readonly meetingRecordingLink: {
        readonly id: string;
        readonly visibility: MeetingRecordingVisibility;
      };
    };
  } | null;
};
export type SendNotesRecordingModal_updateRecordingVisibilityMutation = {
  rawResponse: SendNotesRecordingModal_updateRecordingVisibilityMutation$rawResponse;
  response: SendNotesRecordingModal_updateRecordingVisibilityMutation$data;
  variables: SendNotesRecordingModal_updateRecordingVisibilityMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "noteId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "visibility"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "noteId",
        "variableName": "noteId"
      },
      {
        "kind": "Variable",
        "name": "visibility",
        "variableName": "visibility"
      }
    ],
    "concreteType": "UpdateMeetingRecordingVisibility",
    "kind": "LinkedField",
    "name": "updateMeetingRecordingVisibility",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Note",
        "kind": "LinkedField",
        "name": "note",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MeetingRecordingLink",
            "kind": "LinkedField",
            "name": "meetingRecordingLink",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "visibility",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SendNotesRecordingModal_updateRecordingVisibilityMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SendNotesRecordingModal_updateRecordingVisibilityMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "f14458778346580bd2b783031d0187f7",
    "id": null,
    "metadata": {},
    "name": "SendNotesRecordingModal_updateRecordingVisibilityMutation",
    "operationKind": "mutation",
    "text": "mutation SendNotesRecordingModal_updateRecordingVisibilityMutation(\n  $noteId: ID!\n  $visibility: MeetingRecordingVisibility!\n) {\n  updateMeetingRecordingVisibility(noteId: $noteId, visibility: $visibility) {\n    note {\n      id\n      meetingRecordingLink {\n        id\n        visibility\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3c63e7eb94159187c6e7186306e61937";

export default node;
